import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const AccountsInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Accounts"
    sectionDisplayName="Accounts Section"
    backRoute="/sections/accounts"
  />
);

export default AccountsInwardConsignment;
